import type { FluxErrorEntityErrorCodes } from '../types.js';

export const FormErrorCodes = {
  FormCreateFailed: {
    code: 'form/create-failed',
    message: 'Erro ao criar o formulário.',
    explanation: 'Ocorreu um erro desconhecido ao tentar criar o formulário. Verifique suas informações e tente novamente.',
    localizations: {},
  },
  FormDeleteFailed: {
    code: 'form/delete-failed',
    message: 'Erro ao excluir o formulário.',
    explanation: 'Ocorreu um erro ao tentar excluir o formulário. Verifique suas informações e tente novamente.',
    localizations: {},
  },
  FormInvalidRegex: {
    code: 'form/invalid-regex',
    message: 'A expressão regular informada é inválida.',
    explanation: 'A expressão regular fornecida no formulário é inválida. Campos que suportam validação por regex exigem uma expressão válida.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Formulário',
        path: '/wiki/docs/pipe/forms#texto-curto',
      },
    ],
  },
  FormNotFound: {
    code: 'form/not-found',
    message: 'Formulário não encontrado.',
    explanation: 'O formulário que você está tentando acessar não foi encontrado.',
    localizations: {},
  },
  FormUpdateFailed: {
    code: 'form/update-failed',
    message: 'Erro ao atualizar o formulário.',
    explanation: 'Ocorreu um erro ao tentar atualizar o formulário. Verifique suas informações e tente novamente.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'form'>;

export const StageCardFormErrorCodes = {
  StageCardFormStageNotHaveForm: {
    code: 'stage-card-form/stage-not-have-form',
    message: 'Esta etapa não possui um formulário associado.',
    explanation: 'A etapa do card não possui um formulário associado.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Configurações da Etapa',
        path: '/wiki/docs/pipe/stages/configuration',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'stage-card-form'>;

export const StageFormErrorCodes = {
  StageFormEmailNotFound: {
    code: 'stage-form/email-not-found',
    message: 'O e-mail associado ao formulário não foi encontrado.',
    explanation: 'O e-mail associado ao formulário da etapa não foi encontrado. Isso pode acontecer em formulários públicos.',
    localizations: {},
  },
  StageFormLinkAlreadyAnswered: {
    code: 'stage-form/link-already-answered',
    message: 'Este formulário já foi respondido.',
    explanation: 'O link para o formulário da etapa já foi respondido. Formulários só podem ser respondidos uma vez por link.',
    localizations: {},
  },
  StageFormLinkNotFound: {
    code: 'stage-form/link-not-found',
    message: 'O link do formulário não foi encontrado.',
    explanation: 'O link para o formulário da etapa não foi encontrado.',
    localizations: {},
  },
  StageFormNotFound: {
    code: 'stage-form/not-found',
    message: 'Formulário da etapa não encontrado.',
    explanation: 'O formulário da etapa que você está tentando acessar não foi encontrado.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'stage-form'>;
